// Welche Welt der Client baut (task-013, offener Befund aus task-012; ADR 0027). Die Welt entsteht
// erst, wenn `hello` da ist, und zwar aus `hello.params` – nicht mehr aus den Standardwerten. Dann
// wird die Kennung der gebauten Welt mit `hello.worldId` verglichen: Weicht sie ab, erzeugt dieser
// Client aus denselben Parametern eine andere Welt als der Server, liegt also vermutlich eine alte
// Fassung im Tab. Dann hilft einmal Neuladen. Dasselbe gilt, wenn nach einer Wiederverbindung ein
// `hello` mit anderer Kennung kommt (Server mit anderer Welt neu gestartet).
//
// Reine Logik ohne DOM; wo sich main.ts das Neuladen merkt, entscheidet main.ts.

/** Unter diesem Schlüssel merkt sich der Tab (sessionStorage), für welche Kennung er schon neu geladen hat. */
export const NEU_GELADEN_SCHLUESSEL = 'bauernhof-welt-neu-geladen';

export type WeltEntscheidung = 'weiter' | 'neu laden' | 'weiter trotz Abweichung';

/**
 * `serverWorldId` aus `hello`, `gebauteWorldId` die Kennung der Welt, die dieser Client gebaut hat,
 * `neuGeladenFuer` die Kennung, für die dieser Tab schon einmal neu geladen hat (oder null). Ein
 * zweites Neuladen für dieselbe Kennung gibt es nicht: Lieber mit einer abweichenden Welt
 * weiterspielen, als endlos zu laden.
 */
export function weltEntscheidung(serverWorldId: string, gebauteWorldId: string, neuGeladenFuer: string | null): WeltEntscheidung {
  if (serverWorldId === gebauteWorldId) return 'weiter';
  return neuGeladenFuer === serverWorldId ? 'weiter trotz Abweichung' : 'neu laden';
}
